import type { SourceRef } from '../lib/types';

interface Props {
  sources: SourceRef[];
}

export function SourceFooter({ sources }: Props) {
  if (!sources?.length) return null;
  return (
    <ul className="mt-4 pt-3 border-t border-ink-200/60 dark:border-ink-700/60 text-[11px] text-ink-500 dark:text-ink-300 space-y-1">
      {sources.map((s, i) => (
        <li key={i}>
          <span className="opacity-70">出典: </span>
          <a
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-dotted underline-offset-2 hover:text-gold-500"
          >
            {s.name}
          </a>
        </li>
      ))}
    </ul>
  );
}
